'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Counter: ()=>Counter
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const index_cjs_namespaceObject = require("../Button/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const external_Counter_variants_cjs_namespaceObject = require("./Counter.variants.cjs");
const external_CounterIconButton_cjs_namespaceObject = require("./CounterIconButton.cjs");
const SlidingNumber_index_cjs_namespaceObject = require("../animations/SlidingNumber/index.cjs");
function Counter({ iconButtonType = 'primary', incrementIconButtonProps = {}, decrementIconButtonProps = {}, ctaButtonProps = {}, emphasis = 'regular', min = 0, max = 10, cta = false, label, className = '', size, disabled = false, handleValueChange, value = min, decrementIconTooltipProps, incrementIconTooltipProps, useSlidingNumber = false }) {
    const id = external_react_default().useId();
    const showCta = cta && 0 === value;
    const [displayCta, setDisplayCta] = (0, external_react_namespaceObject.useState)(showCta);
    const hideCta = ()=>{
        handleValueChange(++value);
        setDisplayCta(false);
    };
    const decrementValue = ()=>{
        const count = --value;
        if (count === min && cta) setDisplayCta(true);
        handleValueChange(count);
    };
    const incrementValue = ()=>{
        handleValueChange(++value);
    };
    const minusDisabled = disabled || value <= min;
    const plusDisabled = disabled || value >= max;
    const minusLabel = `Decrease ${label}${minusDisabled ? ' - disabled' : ''}`;
    const plusLabel = `Increase ${label}${plusDisabled ? ' - disabled' : ''}`;
    const addButtonType = external_Counter_variants_cjs_namespaceObject.counterIconButtonVariants[iconButtonType].add;
    const removeButtonType = external_Counter_variants_cjs_namespaceObject.counterIconButtonVariants[iconButtonType].remove;
    const { size: ctaSize = 'sm', children: ctaChildren = 'Add', iconLeft = 'add', ...restProps } = ctaButtonProps;
    const { root, ctaButton, numericText } = (0, external_Counter_variants_cjs_namespaceObject.counterVariants)({
        emphasis,
        size
    });
    const rootClasses = (0, cn_cjs_namespaceObject.cn)(root(), className);
    if (displayCta) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Button, {
        "data-testid": "counter-cta-button",
        size: ctaSize,
        children: ctaChildren,
        onClick: hideCta,
        type: iconButtonType,
        iconLeft: iconLeft,
        emphasis: emphasis,
        disabled: disabled,
        className: ctaButton(),
        ...restProps
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        role: "group",
        "aria-label": `${label} counter controls`,
        className: rootClasses,
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CounterIconButton_cjs_namespaceObject.CounterIconButton, {
                type: "decrement",
                ariaLabel: minusLabel,
                ariaControls: id,
                onClick: decrementValue,
                tooltipProps: decrementIconTooltipProps,
                buttonType: removeButtonType,
                disabled: minusDisabled,
                emphasis: emphasis,
                iconButtonProps: decrementIconButtonProps
            }),
            useSlidingNumber ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: "w-10 items-center justify-center whitespace-nowrap text-center",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(SlidingNumber_index_cjs_namespaceObject.SlidingNumber, {
                    value: value,
                    className: numericText(),
                    "data-testid": "counter-value"
                })
            }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                align: "center",
                id: id,
                "aria-live": "polite",
                "aria-atomic": "true",
                className: numericText(),
                "data-testid": "counter-value",
                children: value
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CounterIconButton_cjs_namespaceObject.CounterIconButton, {
                type: "increment",
                ariaLabel: plusLabel,
                ariaControls: id,
                onClick: incrementValue,
                tooltipProps: incrementIconTooltipProps,
                buttonType: addButtonType,
                disabled: plusDisabled,
                emphasis: emphasis,
                iconButtonProps: incrementIconButtonProps
            })
        ]
    });
}
exports.Counter = __webpack_exports__.Counter;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Counter"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
